/**
 * @internal
 */
export function createDialogCancelError(output) {
    var error = new Error('Operation cancelled.');
    error.wasCancelled = true;
    error.output = output;
    return error;
}



//////////////////
// WEBPACK FOOTER
// ./~/aurelia-dialog/dist/native-modules/dialog-cancel-error.js
// module id = 79
// module chunks = 0